'use client'

import React, { useState } from 'react'
import type { GalleryBlock as GalleryBlockProps, Media } from '@/payload-types'
import Image from 'next/image'
import { isMedia, convertMediaForLightbox } from '@/lib/utils'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen'
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'

export function GalleryBlock({
  title,
  lead,
  images,
}: Readonly<GalleryBlockProps>): React.ReactNode {
  const [open, setOpen] = useState(false)
  const [index, setIndex] = useState(-1)

  if (!images.length) return null

  const slides = convertMediaForLightbox(images as Media[])

  const handleOpen = (index: number) => {
    setOpen(true)
    setIndex(index)
  }

  return (
    <>
      <section className="group p-8 [.group+&]:border-t">
        <div className="flex flex-col max-w-7xl mx-auto gap-8">
          {title || lead ? (
            <header className="lg:flex-1 flex flex-col gap-4 self-center text-center">
              {title ? <h2 className="text-lg lg:text-xl font-semibold">{title}</h2> : null}
              {lead ? <p className="text-sm">{lead}</p> : null}
            </header>
          ) : null}
          {images ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {images.map((image, index) =>
                isMedia(image) && image.url ? (
                  <figure key={image.id} className="overflow-hidden">
                    <button onClick={() => handleOpen(index)} className="hover:cursor-pointer">
                      <Image
                        className="rounded-lg aspect-auto object-cover"
                        src={image.url}
                        alt={image.alt}
                        width={Number(image.width)}
                        height={Number(image.height)}
                      />
                    </button>
                  </figure>
                ) : null,
              )}
            </div>
          ) : null}
        </div>
      </section>
      <Lightbox
        slides={slides}
        open={open}
        index={index}
        close={() => setOpen(false)}
        plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
      />
    </>
  )
}
